<div class="container-fluid">
  <ng-container
    *ngIf="learningObjectiveInfoState$ | async as learningObjectiveInfoState"
  >
    <ng-container *ngIf="learningObjectiveInfoState.learningObjective">
      <div class="lo-info-header row border-bottom px-3 py-1">
        <div
          class="col-12 offset-lg-2 col-lg-8 d-flex justify-content-between align-items-center"
        >
          <h4 class="m-0">Leerdoelinfo</h4>
          <button (click)="close()" class="btn btn-primary mdi mdi-close">
            Sluiten
          </button>
        </div>
      </div>

      <div class="row p-3">
        <div class="col-12 offset-lg-2 col-lg-8">
          <h5
            *ngIf="
              (selectedCitoModule$ | async) === 0 &&
              learningObjectiveInfoState.learningObjective.subjectCode
            "
          >
            Doelstelling
          </h5>
          <p
            *ngIf="
              (selectedCitoModule$ | async) === 0 &&
              learningObjectiveInfoState.learningObjective.subjectCode
            "
          >
            {{ learningObjectiveInfoState.learningObjective.subjectCode }}
          </p>

          <ng-container
            *ngIf="learningObjectiveInfoState.learningObjective.domainTitle"
          >
            <h5>Domein</h5>
            <p>
              {{ learningObjectiveInfoState.learningObjective.domainTitle }}
            </p>
          </ng-container>

          <ng-container
            *ngIf="
              (selectedCitoModule$ | async) === 1 &&
              learningObjectiveInfoState.learningObjective.subjectCode
            "
          >
            <h5>Spellingcategorie</h5>
            <p>
              {{ learningObjectiveInfoState.learningObjective.subjectCode }}
            </p>
          </ng-container>

          <h5>LVS-toets</h5>
          <p
            *ngIf="
              learningObjectiveInfoState.learningObjective.tagList.length > 0
            "
          >
            {{
              learningObjectiveInfoState.learningObjective.tagList.join(", ")
            }}
          </p>
          <p
            *ngIf="
              learningObjectiveInfoState.learningObjective.tagList.length === 0
            "
          >
            -
          </p>

          <h5>Omschrijving</h5>
          <p>
            {{ stripDescription(learningObjectiveInfoState.learningObjective.description) }}
          </p>

          <h5>Leerlingomschrijving</h5>
          <p>
            {{ learningObjectiveInfoState.learningObjective.titleCandidate }}
          </p>
          <ng-container
            *ngIf="
              learningObjectiveInfoState.learningObjective.childLanguageAudio
            "
          >
            <h5>Kindertaal</h5>
            <audio #audio class="child-audio mb-5" controls>
              <source
                [src]="
                  'assets/audio/' +
                  learningObjectiveInfoState.learningObjective
                    .childLanguageAudio
                "
                type="audio/mpeg"
              />
              Your browser does not support the audio element.
            </audio>
          </ng-container>
          <div>
            <tabset #tabset>
              <tab heading="Voorbeeld" id="example">
                <ng-container
                  *ngIf="learningObjectiveInfoState.learningObjective.image"
                >
                  <img
                    [src]="
                      'assets/example/' +
                      learningObjectiveInfoState.learningObjective.image
                    "
                    class="w-100"
                  />
                </ng-container>
                <ng-container
                  *ngIf="!learningObjectiveInfoState.learningObjective.image"
                >
                  <p class="pt-2">
                    <i>Voor dit leerdoel is nog geen voorbeeld beschikbaar</i>
                  </p>
                </ng-container>
              </tab>
              <tab
                heading="Video"
                *ngIf="
                  learningObjectiveInfoState.learningObjective
                    .hasLaatEensZienClip && learningObjectiveInfoState.videoWebm
                "
              >
                <div class="video">
                  <video width="100%" controls>
                    <source
                      [src]="learningObjectiveInfoState.videoWebm"
                      type="video/webm"
                    />
                    <source
                      [src]="learningObjectiveInfoState.videoMp4"
                      type="video/mp4"
                    />
                  </video>
                </div>
              </tab>
            </tabset>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
